import { ReactNode } from 'react';

import { Box, FormControl, FormLabel, Typography } from '@mui/material';

export function LabelInput({
	label,
	subLabel,
	fieldName,
	labelEnd,
	children,
}: {
	label: ReactNode;
	subLabel?: ReactNode;
	fieldName: string;
	labelEnd?: ReactNode;
	children: ReactNode;
}) {
	let labelContent: ReactNode;

	if (typeof label === 'string') {
		labelContent = (
			<Typography
				variant="subtitle2"
				component="span"
				sx={{
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				{label}
				{!!subLabel && (
					<Typography
						variant="body2"
						component="span"
						sx={{
							fontSize: 12,
						}}
					>
						{subLabel}
					</Typography>
				)}
			</Typography>
		);
	} else {
		labelContent = label;
	}

	return (
		<FormControl
			variant="outlined"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: 0.5,
				width: '100%',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'baseline',
					justifyContent: 'space-between',
				}}
			>
				<FormLabel htmlFor={fieldName}>{labelContent}</FormLabel>
				{labelEnd}
			</Box>
			{children}
		</FormControl>
	);
}

export const Optional = () => (
	<Typography
		variant="caption"
		sx={{
			color: 'text.secondary',
			fontSize: 12,
		}}
	>
		Optional
	</Typography>
);

LabelInput.Optional = Optional;
